import axios from 'axios';

export const getAdminEventList = search => axios.get('/config/event_list/', { params: { ...search } });
